

















import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseHelpMessage from '../base-help-message/_base-help-message.vue';

@Component({
  name: 'BaseInputBox',
  components: {
    BaseHelpMessage,
  },
})
export default class BaseInputBox extends Vue {
  @Prop() label: string;
  @Prop({ default: false }) error: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop({ default: false }) active: boolean;
  @Prop() disabled: boolean;
  @Prop() forId: string;
}
